<template>
  <div>
    <baseFrame
      submitText="提交"
      clearText=""
      saveText=""
      :submitLoading="submitLoading"
      @submit="handleCuringRuleSubmit"
      @cancel="handleToCuringRuleList">
      <div slot="content" class="curing-rule-form">
        <lk-card title="养护规则信息">
          <!-- isDefaultRule 编辑默认的养护规则 -->
          <lk-form
            v-if="isDefaultRule"
            :label-width="134"
            :model="curingRuleDefault"
            :rules="curingRuleDefaultRules"
            ref="curingRuleDefaultForm">
            <lk-row :gutter="16">
              <lk-col span="7">
                <lk-form-item label="规则名称:" prop="name">
                  <lk-input :maxlength="50" clearable v-model.trim="curingRuleDefault.name"></lk-input>
                </lk-form-item>
              </lk-col>
              <lk-col span="7" offset="1">
                <lk-form-item label="养护标准:">
                  <span>{{standardMap.get(curingRuleDefault.standard)}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span="7" offset="1">
                <lk-form-item label="养护周期:" prop="cycle">
                  <lk-select v-model="curingRuleDefault.cycle" clearable>
                    <lk-option v-for="item in (curingRuleDefault.standard === 1 ? commonCycleArray : importantCycleArray)" :key="item.id" :value="item.id">
                      {{item.name}}
                    </lk-option>
                  </lk-select>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter="16">
              <lk-col span="7">
                <lk-form-item label="养护范围:" prop="warehouseIds">
                  <lk-select
                    multiple
                    v-model="curingRuleDefault.warehouseIds"
                    clearable
                    placeholder="请选择"
                    label-in-value
                    @on-change="handleWarehouse2">
                    <lk-option v-for="item in warehouses" :key="item.id" :value="item.id">
                      {{item.name}}
                    </lk-option>
                  </lk-select>
                </lk-form-item>
              </lk-col>
              <lk-col span="7" offset="1">
                <lk-form-item label="养护提醒:" prop="alertDays">
                  <lk-select v-model="curingRuleDefault.alertDays" clearable key="alertDays">
                    <lk-option v-for="item in alertDaysArray" :key="item.id" :value="item.id">
                      {{item.name}}
                    </lk-option>
                  </lk-select>
                </lk-form-item>
              </lk-col>
            </lk-row>
          </lk-form>
          <lk-form
            v-else
            :label-width="134"
            :model="curingRule"
            :rules="formRules"
            ref="curingRuleForm">
            <lk-row :gutter="16">
              <lk-col span="7">
                <lk-form-item label="规则名称:" prop="name">
                  <lk-input clearable :maxlength="50" v-model.trim="curingRule.name"></lk-input>
                </lk-form-item>
              </lk-col>
              <lk-col span="7" offset="1">
                <lk-form-item label="养护标准:" prop="standard">
                  <lk-select v-model="curingRule.standard" clearable
                             placeholder="请选择" @on-change="handleChangeStandard($event, curingRule)">
                    <lk-option v-for="item in standardList" :key="item.id" :value="item.id">
                      {{item.name}}
                    </lk-option>
                  </lk-select>
                </lk-form-item>
              </lk-col>
              <lk-col span="7" offset="1">
                <lk-form-item label="养护周期(天):" prop="cycle">
                  <template>
                    <lk-input-number style="width:100%;" v-if="curingRule.standard === 2" v-model.trim="curingRule.cycle" clearable :min="1" :max="30">
                    </lk-input-number>
                    <lk-input-number style="width:100%;" v-else v-model.trim="curingRule.cycle" clearabl :min="1" :max="90">
                    </lk-input-number>
                  </template>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter="16">
              <lk-col span="7">
                <lk-form-item
                  label="养护提醒(天):"
                  prop="alertDays">
                  <lk-input-number
                    style="width:100%;"
                    v-model.trim="curingRule.alertDays"
                    clearable
                    :min="1"
                    :max="10">
                  </lk-input-number>
                </lk-form-item>
              </lk-col>
              <lk-col span="7" offset="1">
                <lk-form-item label="优先级:" prop="priority">
                  <lk-select
                    v-model="curingRule.priority" clearable
                    key="priority"
                    placeholder="请选择">
                    <lk-option v-for="item in priorityList" :key="item.id" :value="item.id">
                      {{item.name}}
                    </lk-option>
                  </lk-select>
                </lk-form-item>
              </lk-col>
              <lk-col span="7" offset="1">
                <lk-form-item label="开始时间:" prop="startTime">
                  <lk-DatePicker
                    style="width:100%;"
                    class="item"
                    :options="createTimeStartOptions()"
                    v-model.trim="curingRule.startTime">
                  </lk-DatePicker>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter="16">
              <lk-col span="7">
                <lk-form-item label="结束时间:" prop="endTime">
                  <lk-DatePicker
                    style="width:100%;"
                    class="item"
                    :options="createTimeEndOptions()"
                    v-model.trim="curingRule.endTime">
                  </lk-DatePicker>
                </lk-form-item>
              </lk-col>
              <lk-col span="7" offset="1">
                <lk-form-item label="使用状态:" prop="status">
                  <lk-select v-model="curingRule.status" clearable placeholder="请选择">
                    <lk-option v-for="(item, index) in statusMap" :value="item[0]" :key="index">
                      {{ item[1] }}
                    </lk-option>
                  </lk-select>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter="16">
              <lk-col span="7">
                <lk-form-item label="养护范围:" prop="containRang">
                  <div>
                    <lk-checkbox :true-value="1" :false-value="2" v-model="curingRule.containExpiry" @on-change="handleChangeContainRang">近效期商品</lk-checkbox>
                    <lk-checkbox :true-value="1" :false-value="2" v-model="curingRule.containExpensive" @on-change="handleChangeContainRang($event, 2)">性状不稳定、贵细商品</lk-checkbox>
                  </div>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter="16">
              <lk-col span="7">
                <lk-form-item label="养护商品:" prop="tableData">
                  <lk-button type="primary" @click="chooseGoods" :disabled="curingRule.containExpensive === 2">选择商品</lk-button>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter="16">
              <lk-col span="23" v-if="curingRule.containExpensive === 1">
                <lk-form-item>
                  <lk-table border :columns="columns" :data="tableData"></lk-table>
                </lk-form-item>
              </lk-col>
            </lk-row>
          </lk-form>
        </lk-card>
      </div>
    </baseFrame>
    <lk-modal
      v-model="goodsModalVisiable"
      :mask-closable="false"
      title="添加商品"
      width="900">
      <div class="queryContainer">
        <div class="queryItem">
          <label>关键词:</label>
          <lk-input :maxlength="100" placeholder="商品编码、助记码、商品名称、通用名称" class="item"
                    clearable v-model.trim="modalQuery.nameMix"></lk-input>
        </div>
        <div class="queryItem">
          <lk-button type="primary" class="mr8" @click="handleModalSearch">查询</lk-button>
          <lk-button @click="clearModalQuery" class="mr8">重置</lk-button>
        </div>
      </div>
      <div style="position: relative;">
        <loading v-show="modalLoading"></loading>
        <lk-table
          border
          :columns="modalColumns"
          :data="modalTableData"
          @on-select="handleTempSelect"
          @on-select-cancel="handleTempCancel"
          @on-select-all="handleSelectAll"
          @on-select-all-cancel="handleSelectAllCancel">
        </lk-table>

        <div style="text-align:right; margin-top: 14px;">
          <lk-page
            :total="modalPage.count"
            :current="modalPage.page"
            :page-size="modalPage.size"
            show-total
            show-sizer
            show-elevator
            @on-change="handleModalPage"
            @on-page-size-change="handleModalPageSize">
          </lk-page>
        </div>
      </div>
      <div slot="footer">
        <div class="queryItem">
          <span class="mr8">已选:{{tableData.length + tempGoods.length}}项</span>
          <lk-button @click="clearModal">取消</lk-button>
          <lk-button type="primary" class="mr" @click="confirmAddGoods">确定</lk-button>
        </div>
      </div>
    </lk-modal>
  </div>
</template>
<script>
import utils from '../../libs/utils';
import baseFrame from '../../components/frame/BaseFrame.vue';
import inventory from '../../services/inventory';
import loading from '../../components/LoadingSpan';
import goodsBase from '../../services/goods';

/*
* 默认规则和自定义规则
* 1、拉取规则列表，若为空则添加2个默认规则（一般、重点）
* 2、重点养护 养护周期10，一般养护30天
* 3、提醒时间不得超过养护时间
* 4、近效期勾选后可以不勾选养护商品，性状不稳定、贵细商品（有商品自动勾选）勾选后可以选择养护商品
* */
export default {
  name: 'curingRuleForm',
  components: {
    baseFrame,
    loading,
  },
  computed: {
    selectedIds() {
      const result = [];
      this.tableData.forEach((item) => {
        result.push(this.getKey(item));
      });
      return result;
    },
    selectedTempGoodsIds() {
      const result = [];
      this.tempGoods.forEach((item) => {
        result.push(this.getKey(item));
      });
      return result;
    },
  },
  data() {
    return {
      curingRule: {
        name: null,
        standard: 1,
        cycle: null,
        alertDays: null,
        priority: 1,
        startTime: new Date(),
        endTime: new Date(),
        status: 1,
        defaultFlag: 2, // 1默认规则 2自定义规则
        containRang: 2, // 验证养护范围用
        containExpiry: 1, // 近效期
        containExpensive: 1, // 性状不稳定、贵细商品
      },
      formRules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' },
          {
            validator: this.isExistCuringRuleName, trigger: 'blur',
          },
        ],
        standard: [
          {
            required: true, message: '请选择养护标准', trigger: 'change', type: 'number',
          },
        ],
        cycle: [
          {
            required: true, message: '请输入养护周期', trigger: 'change', type: 'number',
          },
          {
            validator: this.isNumberValidator, trigger: 'change',
          },
        ],
        alertDays: [
          {
            required: true, message: '请输入养护提醒', trigger: 'change', type: 'number',
          },
          {
            validator: this.isNumberValidator, trigger: 'change',
          },
          {
            validator: (rule, value, callback) => {
              if (value) {
                if (this.curingRule.cycle) {
                  if (value <= this.curingRule.cycle) {
                    callback();
                  } else {
                    callback(new Error('养护提醒天数必须小于等于养护周期'));
                  }
                }
                callback();
              } else {
                callback(new Error('请输入养护提醒天数'));
              }
            },
            trigger: 'change',
          },
        ],
        priority: [
          {
            required: true, message: '请选择优先级', trigger: 'change', type: 'number',
          },
        ],
        startTime: [
          {
            required: true, message: '请选择开始时间',
          },
        ],
        endTime: [
          {
            required: true, message: '请选择结束时间',
          },
          {
            validator: this.isEndTimeValidator, trigger: 'change',
          },
        ],
        status: [
          {
            required: true, message: '请选择使用状态', trigger: 'change', type: 'number',
          },
        ],
        containRang: {
          required: true, message: '请选择养护范围',
        },
      },
      columns: [
        { title: '序号', type: 'index', width: 60 },
        { title: '商品编码', key: 'drugSerialCode', minWidth: 110 },
        { title: '助记码', key: 'mnemonicCode', minWidth: 110 },
        { title: '商品名称', key: 'goodsName', minWidth: 110 },
        { title: '通用名称', key: 'approvedDrugName', minWidth: 110 },
        { title: '规格', key: 'spec', minWidth: 110 },
        { title: '单位', key: 'drugMiniPackageUnitString', minWidth: 110 },
        { title: '生产厂家', key: 'producer', minWidth: 110 },
        { title: '剂型', key: 'dosageFormName', minWidth: 110 },
        {
          title: '操作',
          key: 'delBtn',
          minWidth: 100,
          fixed: 'right',
          render: (h, { index }) => h('div', [
            h('lk-button', {
              props: {
                type: 'text',
              },
              on: {
                click: () => {
                  this.tableData.splice(index, 1);
                },
              },
            }, '删除'),
          ]),
        },
      ],
      tableData: [],
      goodsModalVisiable: false,
      modalLoading: false,
      submitLoading: false,
      modalQuery: {
        nameMix: null,
      },
      modalParams: {},
      modalTableData: [],
      standardList: [{
        id: 1,
        name: '一般养护',
      }, {
        id: 2,
        name: '重点养护',
      }],
      priorityList: [{
        id: 1,
        name: '低',
      }, {
        id: 2,
        name: '中',
      }, {
        id: 3,
        name: '高',
      }],
      statusMap: new Map([
        [1, '启用'],
        [2, '禁用'],
      ]),
      tempGoods: [],
      modalPage: {
        page: 1,
        size: 10,
        count: 0,
      },
      modalColumns: [
        {
          title: '选择', key: 'id', type: 'selection', width: 60,
        },
        { title: '商品编码', key: 'drugSerialCode', minWidth: 110 },
        { title: '助记码', key: 'mnemonicCode', minWidth: 110 },
        { title: '商品名称', key: 'goodsName', minWidth: 110 },
        { title: '通用名称', key: 'approvedDrugNames', minWidth: 110 },
        { title: '规格', key: 'specifications', minWidth: 110 },
        { title: '单位', key: 'drugMiniPackageUnitString', minWidth: 110 },
        { title: '生产厂家', key: 'manufacturer', minWidth: 110 },
        { title: '剂型', key: 'dosageFormName', minWidth: 110 },
      ],
      curingRuleId: null,
      isDefaultRule: false,
      curingRuleDefault: {},
      curingRuleDefaultRules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' },
          {
            validator: this.isExistCuringRuleName, trigger: 'blur',
          },
        ],
        cycle: [
          {
            required: true, message: '请选择养护周期', trigger: 'change', type: 'number',
          },
        ],
        alertDays: [
          {
            required: true, message: '请选择养护提醒', trigger: 'change', type: 'number',
          },

        ],
        warehouseIds: [
          {
            required: true, message: '请选择养护范围', trigger: 'change', type: 'array',
          },
        ],
      },
      standardMap: new Map([
        [1, '一般养护'],
        [2, '重点养护'],
      ]),
      commonCycleArray: [
        {
          id: 15,
          name: ' 15天',
        },
        {
          id: 30,
          name: '30天',
        },
        {
          id: 90,
          name: '90天',
        },
      ],
      importantCycleArray: [
        {
          id: 15,
          name: ' 15天',
        },
        {
          id: 30,
          name: '30天',
        },
      ],
      warehouses: [],
      alertDaysArray: [
        {
          id: 1,
          name: '1天',
        },
        {
          id: 2,
          name: '2天',
        },
        {
          id: 3,
          name: '3天',
        },
        {
          id: 4,
          name: '4天',
        },
        {
          id: 5,
          name: '5天',
        }, {
          id: 6,
          name: '6天',
        },
        {
          id: 7,
          name: '7天',
        },
        {
          id: 8,
          name: '8天',
        },
        {
          id: 9,
          name: '9天',
        },
        {
          id: 10,
          name: '10天',
        },
      ],
    };
  },
  methods: {
    chooseGoods() {
      this.clearModalQuery(); // 重置参数
      this.tempGoods = [];
      this.goodsModalVisiable = true;
      this.modalParams = utils.deepClone(this.modalQuery);
      this.handleModalPage(1, true);
    },
    handleModalPage(page, isSearch) {
      this.modalPage.page = page;
      if (isSearch) {
        this.modalPage.size = 10;
      }
      this.getGoodsData();
    },
    handleModalPageSize(size) {
      this.modalPage.size = size;
      this.modalPage.page = 1;
      this.getGoodsData();
    },

    handleGoodsPage(val) {
      this.goodsPage.page = val;
      this.getGoodsData();
    },
    handleGoodsSize(val) {
      this.goodsPage.size = val;
      this.getGoodsData();
    },
    getGoodsData() {
      this.modalParams.page = this.modalPage.page;
      this.modalParams.size = this.modalPage.size;
      this.modalLoading = true;
      this.$store.commit('setDisableLoading', true);

      goodsBase.listGoodsStores(this.modalParams).then((res) => {
        if (res.data.status === 200) {
          const { count, list } = res.data.data;
          this.modalTableData = [];
          list.forEach((item) => {
            const result = {};
            utils.exchangeTable(item.goodsBaseVO.goodsBase, result);
            item.goodsStore.goodsStoreId = item.goodsStore.id;
            utils.exchangeTable(item.goodsStore, result);
            result.dosageFormName = item.goodsBaseVO.dosageFormString; // 剂型
            result.drugMiniPackageUnitString = item.goodsBaseVO.drugMiniPackageUnitString; // 单位

            // 选择商品的接口返回数据与详情中goodsInfoVoList的字段不一致，此处做个转换
            result.approvedDrugName = result.approvedDrugNames;
            result.spec = result.specifications;
            result.producer = result.manufacturer;

            const key = this.getKey(result);
            result.updateIndex = this.updateIndex;
            result._checked = this.selectedIds.includes(key) || this.selectedTempGoodsIds.includes(key);
            result._disabled = this.selectedIds.includes(key);
            this.modalTableData.push(result);
          });
          this.modalPage.count = count;
        } else {
          this.$Message.error(res.data.error);
        }
        this.modalLoading = false;
      }).catch((err) => {
        this.modalLoading = false;
        utils.handleError(err);
      });
    },
    handleChangeStandard(value, item) {
      /*
       * 1 一般养护 1-90
       * 2 重点养护 1-30
       */
      if (value === 2) {
        if (item.cycle > 30) {
          item.cycle = 30;
        }
      }
    },
    handleModalSearch() {
      this.tempGoods = []; // 重新查询商品时，清空之前选择的商品
      this.modalParams = utils.deepClone(this.modalQuery);
      this.handleModalPage(1, true);
    },
    confirmAddGoods() {
      this.tableData.push(...utils.deepClone(this.tempGoods));
      this.goodsModalVisiable = false;
    },
    clearModalQuery() {
      this.modalQuery = {
        nameMix: null,
      };
    },
    handleCuringRuleSubmit() {
      if (this.curingRuleId) { // 编辑规则
        this.handleCuringRuleEdit();
      } else { // 新建养护规则
        this.handleCuringRuleAdd();
      }
    },
    handleCuringRuleAdd() { // 新建
      this.$refs.curingRuleForm.validate((valid) => {
        if (valid) {
          const params = Object.assign({}, this.curingRule);
          params.startTime = new Date(this.curingRule.startTime).getTime();
          params.endTime = new Date(this.curingRule.endTime).getTime();
          params.defaultFlag = 2;
          params.goodsStoreIds = this.getGoodsStoreIds();
          params.goodsStoreIdsStr = params.goodsStoreIds.join(',');

          if (params.defaultFlag === 2) {
            if (params.containExpensive === 1 && this.tableData.length === 0) {
              this.$Message.error('请选择需要养护的商品!');
              return false;
            }
          }

          inventory.addCuringRule(params).then((res) => {
            if (res.data.status === 200) {
              this.$Message.success('保存成功');
              this.handleToCuringRuleList();
            } else {
              this.$Message.error(res.data.error);
            }
          }).catch((err) => {
            utils.handleError(err);
          });
        } else {
          this.$Message.error('请按照要求填写!');
        }
      });
    },
    handleCuringRuleEdit() { // 编辑
      // 编辑默认或者默认
      const type = this.isDefaultRule && this.curingRuleId;
      const form = type ? this.$refs.curingRuleDefaultForm : this.$refs.curingRuleForm;
      form.validate((valid) => {
        if (valid) {
          const curingRule = type ? this.curingRuleDefault : this.curingRule;
          const params = utils.deepClone(curingRule);
          if (params.defaultFlag === 1) {
            params.warehouseIds = curingRule.warehouseIds;
            delete params.warehouseIdsStr;
            delete params.startTime;
            delete params.endTime;
          }

          if (params.defaultFlag === 2) { // 自定义规则
            /*
            * 如果"近效期商品"被选中，可以不选择养护商品; containExpiry: 近效期商品
            * 如果"性状不稳定、贵细商品"被选中，必须选择养护商品; containExpensive: 性状不稳定、贵细商品
            * */
            if (params.containExpensive === 1 && this.tableData.length === 0) {
              this.$Message.error('请选择需要养护的商品!');
              return false;
            }

            params.startTime = new Date(curingRule.startTime).getTime();
            params.endTime = new Date(curingRule.endTime).getTime();
            params.goodsStoreIds = this.getGoodsStoreIds();
            params.goodsStoreIdsStr = params.goodsStoreIds.join(',');
          }

          inventory.updateCuringRule(params).then((res) => {
            if (res.data.status === 200) {
              this.$Message.success('更新成功');
              this.handleToCuringRuleList();
            } else {
              this.$Message.error(res.data.error);
            }
          }).catch((err) => {
            utils.handleError(err);
          });
        } else {
          this.$Message.error('请按照要求填写!');
        }
      });
    },
    getGoodsStoreIds() {
      const goodsStoreIds = [];
      this.tableData.forEach((item) => {
        goodsStoreIds.push(item.goodsStoreId);
      });
      return goodsStoreIds;
    },
    isNumberValidator(rule, value, callback) {
      if (utils.forbiddenDate.signlessIntegerValidator(value)) {
        callback();
      } else {
        callback(new Error('请输入正整数'));
      }
    },
    isEndTimeValidator(rule, value, callback) {
      const vm = this;
      if (value && vm.curingRule.startTime) {
        if (value.getTime() < vm.curingRule.startTime.getTime()) {
          callback(new Error('结束时间必须大于等于开始时间'));
        }
      }
      callback();
    },
    createTimeStartOptions() {
      return {
        disabledDate(time) {
          if (time) {
            return utils.forbiddenDate.disabledToToday(time);
          }
        },
      };
    },
    createTimeEndOptions() {
      const vm = this;
      return {
        disabledDate(time) {
          if (time && vm.curingRule.startTime) {
            return time.getTime() < vm.curingRule.startTime.getTime();
          }
        },
      };
    },
    hideModal() {
      this.goodsModalVisiable = false;
    },
    handleTempSelect(selection, row) {
      if (!this.selectedTempGoodsIds.includes(this.getKey(row))) {
        this.tempGoods.push(row);
      }
    },
    handleTempCancel(selection, row) {
      this.tempGoods.forEach((item, index) => {
        if (this.getKey(item) === this.getKey(row)) {
          this.tempGoods.splice(index, 1);
        }
      });
    },
    handleSelectAll(selection) {
      selection.forEach((item) => {
        if (!this.selectedTempGoodsIds.includes(this.getKey(item)) && !this.selectedIds.includes(this.getKey(item))) {
          this.tempGoods.push(item);
        }
      });
    },
    handleSelectAllCancel() {
      this.modalTableData.forEach((good) => {
        for (let i = 0, len = this.tempGoods.length; i < len; i++) {
          if (this.getKey(this.tempGoods[i]) === this.getKey(good)) {
            this.tempGoods.splice(i, 1);
            break;
          }
        }
      });
    },
    clearModal() {
      this.hideModal();
      this.clearModalQuery();
      this.modalTableData = [];
    },
    isExistCuringRuleName(rule, value, callback) {
      const type = this.isDefaultRule && this.curingRuleId;
      const curingRule = type ? this.curingRuleDefault : this.curingRule;
      if (this.curingRuleId > 0 && (curingRule.originName || curingRule.originName) === value) {
        callback();
        return;
      }

      this.$store.commit('setDisableLoading', true);
      inventory.isCuringRuleNameExist({ name: value }).then((res) => {
        if (res.data.status === 200) {
          if (res.data.data) {
            callback(new Error('规则名称已存在'));
          } else {
            callback();
          }
        } else {
          this.$Message.error(res.data.error);
          callback();
        }
      }).catch((err) => {
        utils.handleError(err);
        callback();
      });
    },
    handleWarehouse2(selection) {
      console.log(selection);
      const names = [];
      if (selection && selection.length > 0) {
        selection.forEach((item) => {
          names.push(item.label);
        });
      }
      // this.curingRuleForm2.warehouseNames = names.join(',');
    },
    getWarehouses() {
      return inventory.warehouseList({
        warehouseType: 1, // 1合格库 2退货区 3不合格品库
      }).then((res) => {
        if (res.data.status === 200) {
          res.data.data.list.forEach((item) => {
            const warehouse = {};
            warehouse.id = item.id;
            warehouse.name = item.warehouseName;
            this.warehouses.push(warehouse);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handleToCuringRuleList() {
      this.$router.push({ name: 'curingRule' });
    },
    handleChangeContainRang(value, type) {
      const flag = value === 1 ? 1 : -1;
      this.curingRule.containRang = Number(this.curingRule.containRang || 0) + flag;
      if (this.curingRule.containRang === 0) {
        this.curingRule.containRang = undefined;
      }
      if (type && value === 2) { // 取消勾选性状不稳定商品
        this.tableData = [];
      }
    },
    getKey(item) {
      return item.goodsStoreId + item.drugMiniPackageUnitString;
    },
  },
  created() {
    this.curingRuleId = this.$route.params.id;
    if (this.curingRuleId) { // 编辑规则
      inventory.getCuringRuleById({ ruleId: this.curingRuleId }).then((res) => {
        if (res.data.status === 200) {
          const { curingRule, goodsInfoVoList } = res.data.data;
          curingRule.originName = curingRule.name;
          curingRule.startTime = new Date(curingRule.startTime);
          curingRule.endTime = new Date(curingRule.endTime);
          if (curingRule.defaultFlag === 1) {
            this.isDefaultRule = true;
            this.curingRuleDefault = curingRule;
            this.getWarehouses();
          } else { // 自定义规则
            // 历史数据： 自定义的养护规则中，养护商品不为空的，将养护范围“性状不稳定、贵细商品”勾选
            if (goodsInfoVoList && goodsInfoVoList.length > 0) {
              curingRule.containExpensive = 1;
            }
            let num = 0;
            if (curingRule.containExpiry === 1) { // 勾选了近效期商品
              num++;
            }
            if (curingRule.containExpensive === 1) { // 勾选了性状不稳定、贵细商品
              num++;
            }
            curingRule.containExpiry = curingRule.containExpiry || 2;
            curingRule.containExpensive = curingRule.containExpensive || 2;
            curingRule.containRang = num; // 养护范围的验证

            this.curingRule = curingRule;
            this.tableData = goodsInfoVoList || [];
          }
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    }
  },
};
</script>
<style lang="less" scoped>
</style>
